import React, { useState, useEffect, useRef } from 'react';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import Moment from 'moment';
import { useForm, Controller } from "react-hook-form";
import { Modal, Alert, Empty, Spin, Select, Tabs, Table, Radio, message, Input, Popover, Upload, Button, Checkbox, List } from 'antd';
import ReactLoading from 'react-loading';
import { Fragment } from 'react';
import { TbUserCheck } from 'react-icons/tb';
import { CheckOutlined, CloseOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { useNavigate, useLocation } from "react-router-dom";
import SendEmailSlider from '../Email/SendEmailSlider';
import { UploadOutlined, DownloadOutlined, SearchOutlined, LoadingOutlined, PrinterOutlined, LeftOutlined, RightOutlined, PlayCircleOutlined, PauseCircleOutlined } from "@ant-design/icons";
import { downloadReportByName } from '../../services/ReportsService';
import ExhibitorBadgesSlider from '../Customers/ExhibitorBadgesSlider';
import ExhibitorFurnishingsSlider from '../Customers/ExhibitorFurnishingsSlider';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';

export default function SuppliedServicesMgr(props) {
    const { register, getValues, setValue, control, watch } = useForm();
    const navigate = useNavigate();
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const { Option } = Select;
    const location = useLocation();

    const [state, setState] = useState({
        showModal: props.showModal,
        shows: [],
        loading: true,
        selectedTargetShow: '',
        showToPrintBadgesFor: {},
        searchRunning: false,
        initialized: false,
        currentPage: 1,
        currentPageSize: 500,
        showsLoaded: false,
        hasSearchBeenRunYet: false,
        selectedFilters: '',
        selectedExhibitorId: '',
        showPane: false,
        showPrintBadgesPane: false,
        selectedExhibitor: {},
        exhibitorBadges: [],
        badgesLoaded: false,
        orderSummaryBoothFurnishings: { tableString: 'None', skirtsString: 'None', topsString: 'None' },
        showOrderLoading: false,
        selectedIndex: null,
        selectedExportFile: 'Select',
        searchValue: '',
        badgeEditMode: 'Add',
        selectedBadges: [],
        badgeList: [],
        originalSelectedBadges: [],
        originalBadgeList: [],
        selected: [],
        originalSelected: [],
        printBadgesMode: 'All',
        loadingBadges: true,
        badgesSliderCallingComponent: '',
        showExhibitorFurnishingsSlider: false,
        furnishingsSliderCallingComponent: ''
    });

    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);
    //const [filteredExhibitors, setfilteredExhibitors] = useState([]);
    const [exhibitors, setExhibitors] = useState([]);
    const [popoverData, setPopoverData] = useState({});
    const [loadingKeys, setLoadingKeys] = useState([]);
    const [isDisabled, setIsDisabled] = useState(true);
    const [exhibitorBadgesIndex, setExhibitorBadgesIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedBadge, setSelectedBadge] = useState(null);
    const [exhibitorBadges, setExhibitorBadges] = useState([]);
    const [deletedBadgeList, setDeletedBadgeList] = useState([]);
    const [originalExhibitorBadges, setOriginalExhibitorBadges] = useState([]);
    const [badgePrinterStatus, setBadgePrinterStatus] = useState(['']);
    const [isPlaying, setIsPlaying] = useState(false);
    const [selectedExhibitor, setSelectedExhibitor] = useState([]);
    const [sortedExhibitors, setSortedExhibitors] = useState([]);

    const toggleItem = (id) => {
        setCheckedItems((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // Calculate max label length for alignment
    const maxLabelLength = Math.max(
        ...exhibitorBadges.map((b) => `${b.badge.fName} ${b.badge.lName}`.length)
    );
    const labelColumnWidth = maxLabelLength * 8;

    useEffect(() => {
        let postdata = {};
        Axios.post(`/api/GetActiveShowList`, postdata
        ).then(response => {
            let shows = response.data;

            setState({
                ...state,
                shows,
                initialized: true
            });

            if (location.state !== null) {
                handleSelectTargetShow(location.state.selectedShow);
            }
        }).catch(error => {
            console.log(error);
        });
    }, [props]);

    useEffect(() => {
        if (state.initialized && location.state !== null) {
            handleSelectTargetShow(location.state.selectedShow);
        }
    }, [state.initialized]);

    useEffect(() => {
        if (state.selectedTargetShow !== '') {
            LoadExhibitors();
            setIsDisabled(false);
        }
    }, [state.selectedTargetShow, state.selectedFilters]);

    useEffect(() => {
        if (state.badgesLoaded === true) {
            PrepareOrderSummarySlider();
        }
    }, [state.badgesLoaded]);

    useEffect(() => {
        if (exhibitorBadges?.length) {
            const initialChecked = Array.from(
                new Set(
                    exhibitorBadges
                        .filter((b) => b.badge.shows?.includes(state.selectedTargetShow))
                        .map((b) => b.badge.exhibitorBadges_ID)
                )
            );
            setCheckedItems(initialChecked);
        }

        setState({
            ...state
        });
    }, [exhibitorBadges]);

    function LoadExhibitors() {
        let delimitedFilters = '';

        setState({
            ...state,
            searchRunning: true
        });

        if (state.selectedFilters.length > 0) {
            delimitedFilters = state.selectedFilters.join('|');
        }

        Axios.get(`/api/GetExhibitorsForSuppliedServicesManager`, {
            params: {
                showcode: state.selectedTargetShow,
                filters: delimitedFilters
            }
        }).then(response => {
            let exhibitors = response.data;

            //setfilteredExhibitors(exhibitors);
            setExhibitors(exhibitors);
            setSortedExhibitors(exhibitors);

            setState({
                ...state,
                hasSearchBeenRunYet: true,
                searchRunning: false,
                loading: false,
                showExhibitorFurnishingsSlider: false
            });

        }).catch(error => {
            console.log(error);
        });
    }

    function closeModal() {
        setState({
            ...state,
            showModal: false
        });
    }

    function openModal() {
        setState({
            ...state,
            showModal: true
        });
    }

    function handleSelectTargetShow(value) {
        if (value === undefined) {
            value = ''

            //setfilteredExhibitors([]);
            setExhibitors([]);
            setSortedExhibitors([]);

            setIsDisabled(true);

            setState({
                ...state,
                selectedTargetShow: '',
                selectedFilters: '',
                selectedExportFile: ''
            });
        }
        else {
            setState({
                ...state,
                selectedTargetShow: value
            });
        }
    }

    function handleSelectFilters(value) {
        if (value === undefined) {
            value = ''
        }

        setState({
            ...state,
            selectedFilters: value
        });
    }

    function handleSelectBroadcastFile(value) {
        if (value === undefined) {
            value = ''
        }

        setState({
            ...state,
            selectedExportFile: value
        });
    }

    function handleResetSearchCriteria() {
        //setfilteredExhibitors([]);
        setSortedExhibitors([]);

        setIsDisabled(true);
        setState({
            ...state,
            selectedTargetShow: '',
            selectedFilters: '',
            selectedExportFile: ''
        });
    }

    function onRadioChange(e) {
        setState({
            ...state,
            callSheetType: e.target.value
        });
    }

    function replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }


    //function formatBoothOrderSubmittedDate(boothFurnishingsOrderSubmitted) {
    //    if (boothFurnishingsOrderSubmitted === '0001-01-01T00:00:00') {
    //        return <CloseOutlined className="text-center" style={{ fontSize: '1.2rem', color: 'red' }} />;
    //    }
    //    else {
    //        return (
    //            <span className="text-center">
    //                <CheckOutlined style={{ fontSize: '1.2rem', color: 'green' }} /><br /> {formatDate(boothFurnishingsOrderSubmitted)}
    //            </span>
    //        );
    //    }
    //}

    function RenderBoothOrderContent(text, record, index) {
        if (record.boothFurnishingsOrderSubmitted === '0001-01-01T00:00:00') {
            //return <CloseOutlined className="text-center" style={{ fontSize: '1.2rem', color: 'red' }} />;
            return (
                <span className="text-center">
                    <CloseOutlined className="text-center" style={{ fontSize: '1.2rem', color: 'red' }} /><br />
                    <Button className="btn btn-link" onClick={() => handleManageExhibitorFurnishings(index)}><u>Manage Furnishings</u></Button>
                </span>
            );
        }
        else {
            return (
                <span className="text-center">
                    <CheckOutlined style={{ fontSize: '1.2rem', color: 'green' }} /><br /> {formatDate(record.boothFurnishingsOrderSubmitted)}
                    <Button className="btn btn-link" onClick={() => handleManageExhibitorFurnishings(index)}><u>Manage Furnishings</u></Button>
                </span>
            );
        }
    }


    function RenderBadgeOrderContent(text, record, index) {
        if (record.badgeOrderSubmitted === '0001-01-01T00:00:00') {
            return <CloseOutlined className="text-center" style={{ fontSize: '1.2rem', color: 'red' }} />;
        }
        else {
            return (
                <span className="text-center">
                    <CheckOutlined style={{ fontSize: '1.2rem', color: 'green' }} /><br /> {formatDate(record.badgeOrderSubmitted)}
                    <Button className="btn btn-link" onClick={() => handlePrintExhibitorBadgesForOneExhibitor(index)}><u>Manage Badges</u></Button>
                </span>
            );
        }
    }

    function formatQtyOrdered(qty) {
        if (qty.toString() === '0') {
            return '';
        }
        else {
            return qty.toString();
        }
    }

    const columns = [
        {
            dataIndex: 'id',
            title: 'Id',
            key: 'id',
            hidden: true
        }, {
            dataIndex: 'name',
            title: 'Exhibitor',
            key: 'name',
            //sorter: (a, b) => a.name.localeCompare(b.name),
            sorter: true,
            align: 'left',
            width: 400
        }, {
            dataIndex: 'booth1',
            title: 'Booth',
            key: 'booth1',
            //sorter: (a, b) => a.booth1.localeCompare(b.booth1),
            sorter: true,
            align: 'left',
            width: 75
        }, {
            dataIndex: 'boothFurnishingsOrderSubmitted',
            title: 'Booth Order',
            key: 'boothFurnishingsOrderSubmitted',
            //sorter: (a, b) => {
            //    const dateA = a.boothFurnishingsOrderSubmitted ? new Date(a.boothFurnishingsOrderSubmitted) : 0;
            //    const dateB = b.boothFurnishingsOrderSubmitted ? new Date(b.boothFurnishingsOrderSubmitted) : 0;
            //    return dateA - dateB;
            //},
            sorter: true,
            render: (text, record, index) => RenderBoothOrderContent(text, record, index),
            //render: (text, record) => formatBoothOrderSubmittedDate(record.boothFurnishingsOrderSubmitted),
            align: 'center',
            width: 175
        }, {
            dataIndex: 'table4',
            title: '4\' Tables',
            key: 'table4',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'table6',
            title: '6\' Tables',
            key: 'table6',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'table8',
            title: '8\' Tables',
            key: 'table8',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'blackSkirt',
            title: 'Black Skirts',
            key: 'blackSkirt',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'blueSkirt',
            title: 'Blue Skirts',
            key: 'blueSkirt',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'graySkirt',
            title: 'Gray Skirts',
            key: 'graySkirt',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'whiteTop',
            title: 'White Tops',
            key: 'whiteTop',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            dataIndex: 'blackTop',
            title: 'Black Tops',
            key: 'blackTop',
            width: 75,
            align: 'center',
            render: (text) => formatQtyOrdered(text)
        }, {
            title: 'Easel Signs',
            key: 'signs',
            render: (text, record) => RenderSignsContent(record),
            width: 75,
            align: 'center'
        }, {
            title: 'Rep Board',
            key: 'repBoard',
            render: (text, record) => RenderRepBoardContent(record),
            width: 75,
            align: 'center'
        }, {
            title: 'Order Comments',
            key: 'orderComments',
            render: (text, record) => RenderBoothOrderCommentsContent(record),
            width: 75,
            align: 'center'
        }, {
            dataIndex: 'badgeOrderSubmitted',
            title: 'Badge Order',
            key: 'badgeOrderSubmitted',
            //sorter: (a, b) => {
            //    const dateA = a.badgeOrderSubmitted ? new Date(a.badgeOrderSubmitted) : 0;
            //    const dateB = b.badgeOrderSubmitted ? new Date(b.badgeOrderSubmitted) : 0;
            //    return dateA - dateB;
            //},
            sorter: true,
            render: (text, record, index) => RenderBadgeOrderContent(text, record, index),
            width: 175,
            align: 'center'
        }, {
            title: 'Order Details',
            key: 'action',
            render: (text, record, index) => (
                state.showOrderLoading && index === state.selectedIndex ?
                    <LoadingOutlined className="text-center hover" style={{ fontSize: '1.2rem' }} />
                    :
                    <div id="orderDetails" className="hover"><SearchOutlined id="orderDetails" className="text-icon" style={{ fontSize: '1.2rem' }} onClick={(e) => showOrderDetails(e, record, index)} /></div>
            ),
            //render: (text, record, index) => (
            //    <div id="jumpTo" className="hover">
            //        {
            //            state.showOrderLoading === false
            //                ? <div id="orderDetails" className="hover"><EyeOutlined id="orderDetails" className="fa-1x text-icon" onClick={(e) => showOrderDetails(e, record)} /></div>
            //                : <LoadingOutlined id="loadingDetails" className="fa-1x text-icon" />
            //        }
            //    </div>
            //),
            //render: (text, record, index) =>
            //    <div id="jumpTo" className="hover"><EyeOutlined id="orderDetails" className="fa-1x text-icon" onClick={(e) => showOrderDetails(e, record)} /></div>
            //,
            align: 'center',
            width: 75
        }, {
            title: 'Jump To',
            key: 'action',
            render: (text, record, index) =>
                <div id="jumpTo" className="hover"><TbUserCheck id="jumpTo" className="fa-1x text-icon" onClick={(e) => handleJumpTo(e, record, index)} /></div>
            ,
            align: 'center',
            width: 75
        }
    ].filter(item => !item.hidden);

    const onSelectChange = (newSelectedRowKeys) => {
        /*console.log('selectedRowKeys changed: ', newSelectedRowKeys);*/
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };
    function handleJumpTo(e, record, index) {
        navigate("/customerview", { state: { selectedCustomerId: record.id, selectedShow: state.selectedTargetShow, callingComponent: 'SuppliedServicesMgr' } });
    }
    function updatePageState(page, pageSize) {
        setState({
            ...state,
            currentPage: page,
            currentPageSize: pageSize
        });
    }

    function handlePrintEaselSigns(exhibitorid) {
        setState({
            ...state,
            selectedExhibitorId: exhibitorid,
        });

        setIsModalOpen(true);
    }

    const RenderSignsContent = (record) => {
        // Build the popover rows as React fragments rather than an HTML
        // string. Easel labels coming from the customer record would render
        // as raw HTML in the old DSI version, which was a stored-XSS sink.
        const easels = [
            ['Easel 1', record.easel1],
            ['Easel 2', record.easel2],
            ['Easel 3', record.easel3],
            ['Easel 4', record.easel4],
            ['Easel 5', record.easel5],
            ['Easel 6', record.easel6],
        ].filter(([, value]) => Boolean(value));

        if (easels.length === 0) return '';

        return (
            <>
                <Popover
                    title={<div>Easel Signs for {record.name}</div>}
                    content={
                        <div>
                            {easels.map(([label, value], i) => (
                                <Fragment key={i}>{label}: {value}<br /></Fragment>
                            ))}
                        </div>
                    }
                    trigger="click"
                >
                    <button type="button" className="btn btn-link btn-lg"><u>{easels.length} Signs</u></button>
                </Popover>
                <Button className="btn btn-link btn-lg" onClick={() => handlePrintEaselSigns(record.id.toString())}><u>Print</u></Button>
            </>
        );
    };

    const RenderRepBoardContent = (record) => {
        const rows = [
            ['City', record.repBoardCity],
            ['State', record.repBoardState],
            ['Contact', record.repBoardContact],
            // The original code keyed Services and Territory off
            // record.repBoardContact (apparent typo). Preserved here so
            // the popover continues to render the same rows.
            ['Services', record.repBoardContact ? record.repBoardServices : null],
            ['Territory', record.repBoardContact ? record.repBoardTerritory : null],
        ].filter(([, value]) => Boolean(value));

        if (rows.length === 0) return '';

        return (
            <Popover
                title={<div>Rep Board Posting for {record.name}</div>}
                content={
                    <div>
                        {rows.map(([label, value], i) => (
                            <Fragment key={i}>{label}: {value}<br /></Fragment>
                        ))}
                    </div>
                }
                trigger="click"
            >
                <button type="button" className="btn btn-link btn-lg"><u>View</u></button>
            </Popover>
        );
    };

    const RenderBoothOrderCommentsContent = (record) => {
        if (!record.boothOrderComments) return '';
        return (
            <Popover
                title={<div>Exhibitor Comments</div>}
                content={
                    <div style={{ whiteSpace: 'pre-wrap' }}>{record.boothOrderComments}</div>
                }
                trigger="click"
            >
                <button type="button" className="btn btn-link btn-lg"><u>View</u></button>
            </Popover>
        );
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const fileUploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        customRequest: async ({ file, onSuccess, onError }) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('exhibitorid', state.selectedExhibitorId); // Replace with your real value
            formData.append('showCode', state.selectedTargetShow); // Replace with your real value

            try {
                const key = "downloademailsigns";
                message.loading({
                    content: 'Easel Sign generation in progress...',
                    key,
                    duration: 0
                });

                const response = await Axios.post(`/api/GenerateEaselSigns`, formData, {
                    responseType: 'blob',
                });
                if (response.data) {
                    
                    //onSuccess(response.data); // Important!

                    //uses the fileName sent down from API enpoint in response header
                    var fileName = response.headers['content-disposition'].replace('filename=', '');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    //a.download = reportName + ".xlsx";
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);

                    message.destroy(key);

                    setIsModalOpen(false);

                    toast.success('Easel Signs generated and downloaded successfully');
                } else {
                    toast.error('Unexpected response');
                    onError(new Error('No data in response'));
                }
            } catch (err) {
                toast.error('Upload failed');
                console.error(err);
                onError(err);
            }
        },
        // Optional: If you want to validate file type or size
        beforeUpload: (file) => {
            const isWord = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            if (!isWord) {
                toast.error('You can only upload Word .docx files!');
            }
            return isWord || Upload.LIST_IGNORE;
        }
    };

    function handleExportFile() {
        if (state.selectedExportFile === 'Select') {
            toast.error('You must select the type of file to export');
            return;
        }

        const key = "downloadfile";
        message.loading({
            content: 'Download in progress...',
            key,
            duration: 0
        });

        let postdata = {
            reportName: state.selectedExportFile,
            showcode: state.selectedTargetShow,
            reportOption: ''
        }

        downloadReportByName(postdata).then(response => {
            if (response.data) {
                //uses the fileName sent down from API enpoint in response header
                var fileName = response.headers['content-disposition'].replace('filename=', '');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                //a.download = reportName + ".xlsx";
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                message.destroy(key);
            } else {
                toast.warning("Report is not yet defined");
            }
        });
    }

    function handlePrintExhibitorBadges() {
        const selectedShow = state.shows.find(s => s.showcode === state.selectedTargetShow);

        setState({
            ...state,
            printBadgesMode: 'All',
            selectedIndex: 0,
            badgesSliderCallingComponent: 'SuppliedServicesMgr',
            showToPrintBadgesFor: selectedShow,
            showPrintBadgesPane: true
        });
    }

    function handlePrintExhibitorBadgesForOneExhibitor(index) {
        const selectedShow = state.shows.find(s => s.showcode === state.selectedTargetShow);

        setState({
            ...state,
            printBadgesMode: 'One',
            selectedIndex: index,
            badgesSliderCallingComponent: 'SuppliedServicesMgr',
            showToPrintBadgesFor: selectedShow,
            showPrintBadgesPane: true
        });
    }

    function handleManageExhibitorFurnishings(index) {
        setState({
            ...state,
            selectedIndex: index,
            furnishingsSliderCallingComponent: 'SuppliedServicesMgr',
            showExhibitorFurnishingsSlider: true
        });
    }

    const hidePane = () => {
        setState({
            ...state,
            showPane: false
        });
    };

    //const hidePrintBadgesPane = () => {
    //    const badgeDataChangedChanged = JSON.stringify(exhibitorBadges) !== JSON.stringify(originalExhibitorBadges);

    //    if (badgeDataChangedChanged) {
    //        confirm({
    //            title: "Changes you have made will not be saved",
    //            content: "Are you sure you would like continue?",
    //            buttons: ["Yes", "No"],
    //        }, (buttonPressed) => {
    //            if (buttonPressed === 'Yes') {
    //                setState({
    //                    ...state,
    //                    showPrintBadgesPane: false
    //                });

    //                return 0;
    //            } else {
    //                return 0;
    //            }
    //        });
    //    }
    //    else {
    //        setState({
    //            ...state,
    //            showPrintBadgesPane: false
    //        });
    //    }
    //};

    function showOrderDetails(e, record, index) {
        //setState({
        //    ...state,
        //    showPane: true
        //});

        getExhibitorBadges(record, index);
    }

    function buildTablesString() {
        let ff = state.selectedExhibitor;

        var tableString = '';
        var skirtsString = '';
        var topsString = '';

        //tables
        if (ff.table4 && ff.table4 > 0) { tableString += ff.table4 === 1 ? "(1) 4' Table, " : "(" + ff.table4 + ") 4' Tables, "; }
        if (ff.table6 && ff.table6 > 0) { tableString += ff.table6 === 1 ? "(1) 6' Table, " : "(" + ff.table6 + ") 6' Tables, "; }
        if (ff.table8 && ff.table8 > 0) { tableString += ff.table8 === 1 ? "(1) 8' Table, " : "(" + ff.table8 + ") 8' Tables, "; }
        tableString = tableString !== '' ? tableString.slice(0, -2) : 'None';

        //skirts
        if (ff.blackSkirt && ff.blackSkirt > 0) { skirtsString += ff.blackSkirt === 1 ? "(1) Black Skirt, " : "(" + ff.blackSkirt + ") Black Skirts, "; }
        if (ff.graySkirt && ff.graySkirt > 0) { skirtsString += ff.graySkirt === 1 ? "(1) Gray Skirt, " : "(" + ff.graySkirt + ") Gray Skirts, "; }
        if (ff.blueSkirt && ff.blueSkirt > 0) { skirtsString += ff.blueSkirt === 1 ? "(1) Royal Blue Skirt, " : "(" + ff.blueSkirt + ") Royal Blue Skirts, "; }
        skirtsString = skirtsString !== '' ? skirtsString.slice(0, -2) : 'None';

        //tops
        if (ff.whiteTop && ff.whiteTop > 0) { topsString += ff.whiteTop === 1 ? "(1) White Top, " : "(" + ff.whiteTop + ") White Tops, "; }
        if (ff.blackTop && ff.blackTop > 0) { topsString += ff.blackTop === 1 ? "(1) Black Top, " : "(" + ff.blackTop + ") Black Tops, "; }
        topsString = topsString !== '' ? topsString.slice(0, -2) : 'None';

        return 'Tables: ' + tableString + '<br />' +
            'Skirts: ' + skirtsString + '<br />' +
            'Tops:   ' + topsString;
    };

    function buildSignsContent() {
        let ff = state.selectedExhibitor;

        const easels = [
            ['Easel 1', ff.easel1?.trim()],
            ['Easel 2', ff.easel2?.trim()],
            ['Easel 3', ff.easel3?.trim()],
            ['Easel 4', ff.easel4?.trim()],
            ['Easel 5', ff.easel5?.trim()],
            ['Easel 6', ff.easel6?.trim()],
        ].filter(([, value]) => Boolean(value));

        if (easels.length === 0) return 'Not Needed';

        return easels.map(([label, value], i) => (
            <Fragment key={i}>
                {label}: {value}
                {i < easels.length - 1 && <br />}
            </Fragment>
        ));
    };

    function buildRepBoardContent() {
        let ff = state.selectedExhibitor;

        if (!(ff.repBoardCity && ff.repBoardState)) {
            return 'Not requested';
        }

        return (
            <>
                City, State: {ff.repBoardCity}, {ff.repBoardState}<br />
                Contact:     {ff.repBoardContact}<br />
                Services:    {ff.repBoardServices}<br />
                Territory:   {ff.repBoardTerritory}
            </>
        );
    };

    function getExhibitorBadges(record, index) {
        setState({
            ...state,
            badgesLoaded: false,
            showOrderLoaded: false,
            showOrderLoading: true,
            selectedIndex: index
        });

        Axios.get(`/api/GetBadgesByShow`, {
            params: {
                id: record.id,
                showcode: state.selectedTargetShow
            }
        }).then(response => {
            let badges = response.data;

            setState({
                ...state,
                exhibitorBadges: badges,
                selectedExhibitor: record,
                badgesLoaded: true,
                showOrderLoaded: true,
                showPane: true,
                showOrderLoading: false
            });
        }).catch(error => {
            console.log(error);
        });
    };

    function buildBadgesContent() {
        let badges = state.exhibitorBadges || [];
        return badges.map((badge, i) => (
            <Fragment key={i}>{badge.fName} {badge.lName}<br /></Fragment>
        ));
    }

    //const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    async function printExhibitorBadgesForShow(printMode) {
        if (getValues().formFields.JSS_BadgeCompany1.trim() === '') {
            toast.error('Company Name Must Be Provided');
            return;
        }

        const selectedShow = state.shows.find(show => show.showcode === state.selectedTargetShow);

        let badges = [];

        if (printMode === 'All') {
            exhibitorBadges.forEach(b => {
                if (checkedItems.includes(b.badge.exhibitorBadges_ID)) {
                    badges.push(b.badge);
                }
            });
        }
        else {
            if (selectedBadge !== null) {
                badges.push(selectedBadge);
            }
            else {
                toast.error('You must select a badge to print');
                return;
            } 
        }

        //await delay(1000);

        let postdata = {};
        postdata.badgeList = badges;
        postdata.showcode = state.selectedTargetShow.toString();
        postdata.show_abbrev = selectedShow.show_abbrev;
        postdata.company1 = getValues().formFields.JSS_BadgeCompany1;
        postdata.company2 = getValues().formFields.JSS_BadgeCompany2;

        Axios.post('/api/PrintExhibitorBadges', postdata
        ).then(async response => {
            if (response.data === 1) {
                toast.success('1 Exhibitor Badge Printed Successfully');
            }
            else {
                toast.success(response.data.toString() + ' Exhibitor Badges Printed Successfully');
            }
        }).catch(error => {
            console.log(error);
        });
    }
    
    function PrepareOrderSummarySlider() {
        let ff = state.selectedExhibitor;

        var tableString = '';
        var skirtsString = '';
        var topsString = '';

        //tables
        if (ff.table4 && ff.table4 > 0) { tableString += ff.table4 === 1 ? "(1) 4' Table, " : "(" + ff.table4 + ") 4' Tables, "; }
        if (ff.table6 && ff.table6 > 0) { tableString += ff.table6 === 1 ? "(1) 6' Table, " : "(" + ff.table6 + ") 6' Tables, "; }
        if (ff.table8 && ff.table8 > 0) { tableString += ff.table8 === 1 ? "(1) 8' Table, " : "(" + ff.table8 + ") 8' Tables, "; }
        tableString = tableString !== '' ? tableString.slice(0, -2) : 'None';

        //skirts
        if (ff.blackSkirt && ff.blackSkirt > 0) { skirtsString += ff.blackSkirt === 1 ? "(1) Black Skirt, " : "(" + ff.blackSkirt + ") Black Skirts, "; }
        if (ff.graySkirt && ff.graySkirt > 0) { skirtsString += ff.graySkirt === 1 ? "(1) Gray Skirt, " : "(" + ff.graySkirt + ") Gray Skirts, "; }
        if (ff.blueSkirt && ff.blueSkirt > 0) { skirtsString += ff.blueSkirt === 1 ? "(1) Royal Blue Skirt, " : "(" + ff.blueSkirt + ") Royal Blue Skirts, "; }
        skirtsString = skirtsString !== '' ? skirtsString.slice(0, -2) : 'None';

        //tops
        if (ff.whiteTop && ff.whiteTop > 0) { topsString += ff.whiteTop === 1 ? "(1) White Top, " : "(" + ff.whiteTop + ") White Tops, "; }
        if (ff.blackTop && ff.blackTop > 0) { topsString += ff.blackTop === 1 ? "(1) Black Top, " : "(" + ff.blackTop + ") Black Tops, "; }
        topsString = topsString !== '' ? topsString.slice(0, -2) : 'None';

        // Store structured summary instead of an HTML string so the SlidingPane
        // can render via React fragments rather than dangerouslySetInnerHTML.
        setState({
            ...state,
            orderSummaryBoothFurnishings: { tableString, skirtsString, topsString },
        });
    }

    const formatDate = (dateInput) => {
        if (dateInput.includes("Z")) {
            const date = new Date(dateInput); // ensure it's a Date object

            const pad = (num) => String(num).padStart(2, '0');

            const mm = pad(date.getUTCMonth() + 1);
            const dd = pad(date.getUTCDate());
            const yyyy = date.getUTCFullYear();

            let hours = date.getUTCHours();
            const minutes = pad(date.getUTCMinutes());

            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            const formattedHours = pad(hours);

            return `${mm}/${dd}/${yyyy} ${formattedHours}:${minutes} ${ampm}`;
        }
        else {
            const formatted = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            }).format(new Date(dateInput)).replace(',', '');

            return formatted;
        }
    }

    function searchExhibitors(value) {
        const searchVal = (value || '').toLowerCase();

        const results = !searchVal
            ? exhibitors
            : exhibitors.filter(e =>
                (e.name || '').toLowerCase().includes(searchVal) ||
                (e.booth1 || '').toLowerCase().includes(searchVal)
            );

        setSortedExhibitors([...results]);
    }

    function searchValueChanged(e) {
        setState({
            ...state,
            searchValue: e.target.value
        });

        searchExhibitors(e.target.value);
    }

    function updateExhibitorsAfterSave(updatedExhibitors) {
        // Build lookup by id
        const updatedMap = new Map(
            updatedExhibitors.map(ex => [ex.id, ex])
        );

        // Merge updates into full exhibitors list
        const newExhibitors = exhibitors.map(ex =>
            updatedMap.has(ex.id)
                ? { ...ex, ...updatedMap.get(ex.id) }
                : ex
        );

        // Update both states
        setSortedExhibitors(updatedExhibitors);
        setExhibitors(newExhibitors);
    }

    function updateAllExhibitorsAfterSave() {
        console.log('ehere');
        LoadExhibitors();
    }

    function handleTableChange(pagination, filters, sorter) {
        if (!sorter.order) {
            setSortedExhibitors(sortedExhibitors);
            return;
        }

        const sorted = [...sortedExhibitors].sort((a, b) => {
            const dir = sorter.order === 'ascend' ? 1 : -1;

            if (sorter.field === 'name') {
                return a.name.localeCompare(b.name) * dir;
            }

            if (sorter.field === 'booth1') {
                return a.booth1.localeCompare(b.booth1) * dir;
            }

            if (sorter.field === 'badgeOrderSubmitted') {
                const dateA = a.badgeOrderSubmitted
                    ? new Date(a.badgeOrderSubmitted).getTime()
                    : 0;

                const dateB = b.badgeOrderSubmitted
                    ? new Date(b.badgeOrderSubmitted).getTime()
                    : 0;

                return (dateA - dateB) * dir;
            }

            if (sorter.field === 'boothFurnishingsOrderSubmitted') {
                const dateA = a.boothFurnishingsOrderSubmitted
                    ? new Date(a.boothFurnishingsOrderSubmitted).getTime()
                    : 0;
                const dateB = b.boothFurnishingsOrderSubmitted
                    ? new Date(b.boothFurnishingsOrderSubmitted).getTime()
                    : 0;

                return (dateA - dateB) * dir;
            }

            return 0;
        });

        setSortedExhibitors(sorted);
    };

    return (
        <>
            <div className="row" style={{ paddingBottom: 10 }}>
                <div className="form-group col-12">
                    <h3 className="frame-heading">
                        D2P Shows Supplied Services Manager
                    </h3>
                </div>
                <div className="form-group col-lg-2">
                    <label className="form-label">Select Target Show</label>
                    <Select className="form-control-custom d-inline-block mt-2" onChange={handleSelectTargetShow} style={{ width: '100%' }} placeholder="Select Target Show" value={state.selectedTargetShow || undefined} allowClear >
                        {state.shows.map((show, idx) => <option key={idx} value={show.showcode}>{show.name}</option>)}
                    </Select>
                </div>
                <div className="form-group col-lg-2">
                    <label className="form-label">Select Filter(s)</label>
                    <Select mode="multiple" className="form-control-custom d-inline-block" onChange={handleSelectFilters} style={{ width: '100%', marginTop: 7 }} placeholder="Select one or more filter" value={state.selectedFilters || undefined} >
                        <option value='Missing Booth Orders'>{'Missing Booth Orders'}</option>
                        <option value='Missing Badge Orders'>{'Missing Badge Orders'}</option>
                        <option value='Orders With Signs'>{'Orders With Signs'}</option>
                        <option value='Orders With Comments'>{'Orders With Comments'}</option>
                    </Select>
                </div>

                <div className="form-group col-lg-2" style={{ marginTop: 25 }}>
                    <button className="btn btn-outline-primary ms-3" onClick={handleResetSearchCriteria}>Reset Selections</button>
                </div>

                <div className="form-group col-lg-4">
                    <label className="form-label">File Exports:&nbsp;</label><br />
                    <Select className="form-control-custom d-inline-block" onChange={handleSelectBroadcastFile} style={{ width: '50%' }} placeholder="Select export type" value={state.selectedExportFile || undefined} disabled={isDisabled} >
                        <option value='Select'>Select</option>
                        <option value='Missing Booth Orders'>Missing Booth Orders Broadcast File</option>
                        <option value='Missing Badge Orders'>Missing Badge Orders Broadcast File</option>
                        <option value='Missing Both Orders'>Missing Both Orders Broadcast File</option>
                        <option value='Decorator Furnishings File'>Decorator Furnishings File</option>
                        <option value='Rep Board Posting File'>Rep Board Posting File</option>
                    </Select>&nbsp;&nbsp;&nbsp;
                    <Button type="primary" icon={<DownloadOutlined />} onClick={handleExportFile} disabled={isDisabled}>
                        Export
                    </Button>
                </div>

                <div className="form-group col-lg-2 pt-4 float-right">
                    <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrintExhibitorBadges} disabled={isDisabled}>
                        Print Exhibitor Badges
                    </Button>
                </div>
            </div>

            <div className="form-group col-lg-12 col-12">
                <hr />
                <Spin spinning={state.searchRunning}>
                    <div style={state.searchRunning ? {} : { display: 'none' }}>
                        <Alert
                            message="Loading Exhibitors..."
                            description="Please stand by while we retrieve exhibitors that match your selected criteria"
                            type="info"
                        />
                    </div>
                    {!state.searchRunning &&
                        <div className="row">
                            {state.selectedTargetShow !== '' &&
                                <Input.Search
                                    style={{ paddingTop: "20px", margin: "0 0 10px 0", width: "50%" }}
                                    placeholder="Search Exhibitors by Name or Booth #..."
                                    enterButton=""
                                    onSearch={searchExhibitors}
                                    allowClear
                                    value={state.searchValue}
                                    onChange={searchValueChanged}
                                />
                            }
                            {sortedExhibitors?.length === 0 ?
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                    <span>
                                        {state.selectedTargetShow === '' ? "Select a show to load exhibitors" : "No exhibitors found matching your search criteria"}
                                    </span>
                                } />
                                :
                                <>
                                    <div className="fullTable form-group col-lg-12">
                                        <Table className="custom-ant-selection"
                                            rowKey={item => item.id}
                                            rowSelection={null}
                                            hideSelectionColumn={true}
                                            bordered
                                            size="small"
                                            dataSource={sortedExhibitors}
                                            columns={columns}
                                            pagination={false}
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: () => {
                                                        let selRows = [record.contact_id];
                                                        setSelectedRowKeys([...selRows]);
                                                    },
                                                    onDoubleClick: (e) => {
                                                        handleJumpTo(e, record, index);
                                                    }
                                                }
                                            }}
                                            scroll={{ y: 600 }}
                                            sticky
                                            tableLayout="auto"
                                            onChange={handleTableChange}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    }
                </Spin>
            </div>

            <Modal
                title="Select Word Template File"
                visible={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="close" onClick={handleCancel}>
                        Close
                    </Button>
                ]}
            >
                <Upload {...fileUploadProps}>
                    <Button icon={<UploadOutlined />}>Click to Select File</Button>
                </Upload>
            </Modal>

            <SlidingPane
                className='some-custom-class'
                overlayClassName='showCard'
                isOpen={state.showPane}
                title={'Order Details for ' + state.selectedExhibitor.name}
                onRequestClose={hidePane}
                closeIcon={<i className="fas fa-chevron-right float-left"></i>}
                width="40%"
            >
                <div className="slide-pane-body scrollableDiv">

                    <div className="row">
                        <div className="col col-5">
                            <strong>Booth Furnishings</strong><br />
                            <div>
                                Tables: {state.orderSummaryBoothFurnishings.tableString}<br />
                                Skirts: {state.orderSummaryBoothFurnishings.skirtsString}<br />
                                Tops:&nbsp;&nbsp;&nbsp;{state.orderSummaryBoothFurnishings.topsString}
                            </div>
                        </div>
                        <div className="col col-7">
                            <strong>Easel Signs</strong><br />
                            <div>{buildSignsContent()}</div>
                        </div>
                    </div>

                    <div className="row pt-3">
                        <div className="col col-12">
                            <strong>Rep Board Posting</strong><br />
                            <div>{buildRepBoardContent()}</div>
                        </div>
                    </div>

                    <div className="row pt-3">
                        <div className="col col-12">
                            <strong>Personnel Badges</strong>&nbsp;&nbsp;&nbsp;
                            {/*<Button type="default" icon={<PrinterOutlined style={{ fontSize: 22 }} />} onClick={printExhibitorBadges} size="large">*/}
                            {/*    Print Badges*/}
                            {/*</Button>*/}
                            <br />
                            <div>{buildBadgesContent()}</div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <div className="form-group col-12 padding-25-10">
                        <button className="btn btn-submit margin-left-15" onClick={hidePane}>Close</button>
                    </div>
                </div>
            </SlidingPane>

            {state.showPrintBadgesPane &&
                <ExhibitorBadgesSlider showPane={state.showShowBadgesSlider} exhibitors={sortedExhibitors} printBadgesMode={state.printBadgesMode} selectedCustomerId={state.selectedCustomerId} selectedIndex={state.selectedIndex}
                    showToPrintBadgesFor={state.showToPrintBadgesFor} hidePane={() => setState({ ...state, showPrintBadgesPane: false })} updateExhibitorsAfterSave={(updatedExhibitors) => updateExhibitorsAfterSave(updatedExhibitors)}
                    badgesSliderCallingComponent={state.badgesSliderCallingComponent} />
            }
            {state.showExhibitorFurnishingsSlider &&
                <ExhibitorFurnishingsSlider showPane={state.showExhibitorFurnishingsSlider} exhibitor={sortedExhibitors[state.selectedIndex]} hidePane={() => setState({ ...state, showExhibitorFurnishingsSlider: false })}
                    updateAllExhibitorsAfterSave={() => updateAllExhibitorsAfterSave()} furnishingsSliderCallingComponent={state.furnishingsSliderCallingComponent} />
            }
        </>
    );
}